import { Table, TableCell, TableHeader } from "@tiptap/extension-table";

/**
 * Iter 120 — Table styling attributes.
 * Borders and shading are stored as inline styles on the <table>/<td>/<th>
 * so an article renders identically in the published view (`.kb-prose`)
 * and round-trips through the editor without losing formatting.
 */
const styleAttr = (name, cssProp) => ({
  default: null,
  parseHTML: (el) => el.style?.[name] || null,
  renderHTML: (attrs) => (attrs[name] ? { style: `${cssProp}: ${attrs[name]}` } : {}),
});

const STYLE_ATTRS = {
  backgroundColor: styleAttr("backgroundColor", "background-color"),
  borderColor: styleAttr("borderColor", "border-color"),
  borderWidth: styleAttr("borderWidth", "border-width"),
  borderStyle: styleAttr("borderStyle", "border-style"),
  padding: styleAttr("padding", "padding"),
  textAlign: styleAttr("textAlign", "text-align"),
  verticalAlign: styleAttr("verticalAlign", "vertical-align"),
};

export const StyledTable = Table.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      ...STYLE_ATTRS,
      // A layout table that wants none of the house look: no borders, no header
      // band, no zebra rows. Rides as a class so the reader and print agree.
      plain: {
        default: null,
        parseHTML: (el) => (el.classList?.contains("kb-table-plain") ? true : null),
        renderHTML: (attrs) => (attrs.plain ? { class: "kb-table-plain" } : {}),
      },
    };
  },
});

/** The table's own node view builds its DOM and ignores `renderHTML`, so the
 *  "plain" marker also rides on every cell — cells are rendered normally, which
 *  is what makes the look change immediately in the editor. */
const PLAIN_CELL = {
  plain: {
    default: null,
    parseHTML: (el) => (el.classList?.contains("kb-cell-plain") ? true : null),
    renderHTML: (attrs) => (attrs.plain ? { class: "kb-cell-plain" } : {}),
  },
};

export const StyledTableCell = TableCell.extend({
  addAttributes() {
    return { ...this.parent?.(), ...STYLE_ATTRS, ...PLAIN_CELL };
  },
});

export const StyledTableHeader = TableHeader.extend({
  addAttributes() {
    return { ...this.parent?.(), ...STYLE_ATTRS, ...PLAIN_CELL };
  },
});

export const TABLE_STYLE_KEYS = Object.keys(STYLE_ATTRS);
